import React from 'react';
import { Navigate } from 'react-router-dom';
import { AdminRoutes } from './views/AdminView/AdminRoutes';
import MainLayout from './layouts/MainLayout';
import ForgotPassword from './views/auth/forgotPassword';
import ResetPassword from './views/auth/resetPassword';
import SignIn from './views/auth/SignIn';
import SignUp from './views/auth/SignUp';
import CompleteSignUp from './views/auth/CompleteSignUp/CompleteSignUp';
import NotFoundView from './views/errors/NotFoundView';
import Logout from './views/auth/logout';
import { SchoolRoutes } from './views/SchoolViews/SchoolRoutes';

const routes = [
  {
    path: '*',
    element: <MainLayout />,
    children: [
      { path: '404', element: <NotFoundView /> },
      { path: '*', element: <Navigate to="/404" /> },
      { path: 'logout', element: <Logout /> }
    ]
  },

  { path: '/', element: <SignIn /> },
  { path: 'signup', element: <SignUp /> },
  { path: 'completeSignUp', element: <CompleteSignUp /> },
  { path: 'forgot-password', element: <ForgotPassword /> },
  { path: 'resetpassword', element: <ResetPassword /> },
  ...AdminRoutes,
  ...SchoolRoutes
];

export default routes;
